import { Injectable } from '@angular/core';
import { SessionService } from './session.service';

const MAX_ITENS = 5;
// rotas que nao fazem sentido como "atalho pra retomar"
const ROTAS_IGNORADAS = ['inicio', 'acesso-negado'];

@Injectable({
  providedIn: 'root'
})
export class HistoricoPaginasService {
  constructor(private readonly sessionService: SessionService) {}

  // grava a rota /dash/xxx navegada, mais recente primeiro, sem duplicatas, limitada a MAX_ITENS.
  // chave por usuario (fora do prefixo OLIVE_ -> sobrevive ao resetSession() do logout).
  registrarPagina(url: string): void {
    const rota = this.extrairRota(url);

    if (!rota || ROTAS_IGNORADAS.includes(rota)) {
      return;
    }

    const historico = this.obterHistorico().filter((item) => item !== rota);
    historico.unshift(rota);

    this.salvarHistorico(historico.slice(0, MAX_ITENS));
  }

  obterHistorico(): string[] {
    try {
      const bruto = localStorage.getItem(this.chave());
      const historico = bruto ? JSON.parse(bruto) : [];

      return Array.isArray(historico) ? historico : [];
    } catch {
      return [];
    }
  }

  private salvarHistorico(historico: string[]): void {
    try {
      localStorage.setItem(this.chave(), JSON.stringify(historico));
    } catch {
      // localStorage indisponivel (modo privado, quota etc) -> ignora, nao quebra navegacao
    }
  }

  private chave(): string {
    return `historico-paginas:${this.sessionService.getSession()?.sid ?? 'anonimo'}`;
  }

  private extrairRota(url: string): string | null {
    const match = url.match(/^\/dash\/([^/?]+)/);

    return match ? match[1] : null;
  }
}
